import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getMemberFormFields = createSelector(membersState, (members) => members?.MemberFormFieldsModel);
